export default __webpack_public_path__ + "static/media/needle.5f168da7.svg";